// extracted by mini-css-extract-plugin
export default {"root":"FileDataFormatSection_root__2nfAM","tabsContainer":"FileDataFormatSection_tabsContainer__2AbIC","tabComponentContainer":"FileDataFormatSection_tabComponentContainer__21GmU"};